import { useEffect, useState } from "react";

const KEY = "scholarly:citation_style";

export function useCitationStyle() {
  const [style, setStyle] = useState(() => localStorage.getItem(KEY) || "apa7");

  useEffect(() => {
    localStorage.setItem(KEY, style);
  }, [style]);

  return [style, setStyle];
}
